import type { FaireProductEntity } from "../../entity_types/product";

export const p_bekf46nckz: FaireProductEntity = {
  token: "p_bekf46nckz",
  type: "product",
  name: 'Skinny Cat Vase-6"H',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/0f27006b890667daea8180b28eaab2501dcd60ad65d94a44fc167f3041986452.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eb2e062c992fe476e95eb625e6e9c954ce731c541be7ec418eb5ad9875990f56.jpeg",
    "https://cdn.faire.com/fastly/9129e8398e0d4ee7d7a76cf5e40d42d1d7abb060e1c2705a3e6c27f882bbc96e.jpeg",
    "https://cdn.faire.com/fastly/d9f7819ea40fc0e97c325517e6a08c9616785655948c4befb1b6c88f633c6cf8.jpeg",
  ],
  priceDollars: 9,
  description:
    'Add the purr-fect touch to your decor with this sleek Tall Cat Vase. Featuring a 6" modern silhouette, this striking feline is finished in a glossy  glaze, accentuated by piercing eyes and delicate ears. Whether displayed alone or as part of a collection, these cat vases bring a touch of cattitude to any space.',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:07.685Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
